import { Outlet } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { LanguageSwitcher } from "@/components/ui/LanguageSwitcher";
import logoLight from "@/assets/SRB.jpg";
import logoDark from "@/assets/SKD.jpg";

export function AuthLayout() {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        {/* Cadre unique : logo + langues + contenu de la page (le logo est
            intégré DANS le cadre, qui s'étend donc vers le haut). Les pages
            auth ne portent plus leur propre cadre. */}
        <div className="bg-surface border border-border rounded-lg p-6 min-h-[470px]">
          {/* Logo */}
          <div className="flex justify-center mb-5">
            <img
              src={theme === "dark" ? logoDark : logoLight}
              alt="Skyline Renting"
              className="w-full object-contain"
            />
          </div>
          {/* Sélecteur de langue (FR / NL / EN) */}
          <LanguageSwitcher className="justify-center mb-6" />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
